(() => {
  const STATE = {
    observer: null,
    busy: false,
    boundRoot: null
  };

  const getGrid = (doc = document) => {
    return (
      doc.querySelector('#product-grid') ||
      doc.querySelector('.product-grid') ||
      doc.querySelector('[data-id="product-grid"]')
    );
  };

  const initLoadMore = () => {
    const root = document.querySelector('[data-load-more]');
    if (!root) return;

    if (STATE.boundRoot === root) return;

    if (STATE.observer) {
      STATE.observer.disconnect();
      STATE.observer = null;
    }

    const btn = root.querySelector('[data-next-url]');
    const sentinel = root.querySelector('[data-sentinel]');

    if (!btn) {
      root.remove();
      STATE.boundRoot = null;
      return;
    }

    STATE.boundRoot = root;

    const setButtonState = (state) => {
      if (!btn) return;

      if (state === 'loading') {
        btn.setAttribute('aria-busy', 'true');
        btn.dataset.originalText ||= btn.textContent.trim();
        btn.textContent = '読み込み中…';
      } else if (state === 'end') {
        root.remove();
        STATE.boundRoot = null;
      } else {
        btn.setAttribute('aria-busy', 'false');
        if (btn.dataset.originalText) btn.textContent = btn.dataset.originalText;
      }
    };

    const fetchAndAppend = async (url) => {
      if (STATE.busy) return;
      STATE.busy = true;
      setButtonState('loading');

      try {
        const res = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');

        const newGrid = getGrid(doc);
        const currentGrid = getGrid(document);

        if (!newGrid || !currentGrid) {
          setButtonState('idle');
          return;
        }

        const items = newGrid.children;
        if (items.length) {
        Array.from(items).forEach((el) => currentGrid.appendChild(el));
        } else {
        currentGrid.insertAdjacentHTML('beforeend', newGrid.innerHTML);
        }

        const relNext = doc.querySelector('link[rel="next"]');
        const nextFromOurMarkup = doc.querySelector('[data-load-more] [data-next-url]');
        const nextFromPagination =
          doc.querySelector('.pagination__item--next a') ||
          doc.querySelector('a[aria-label*="Next"], a[aria-label*="次"]');

        const nextUrl = relNext?.href || nextFromOurMarkup?.href || nextFromPagination?.href || null;

        if (nextUrl) {
          btn.href = nextUrl;
          setButtonState('idle');
        } else {
          setButtonState('end');
        }
      } catch (e) {
        console.error('Load more error:', e);
        setButtonState('idle');
      } finally {
        STATE.busy = false;
      }
    };

    btn.addEventListener('click', (e) => {
      e.preventDefault();
      fetchAndAppend(btn.href);
    }, { once: true });

const targetToObserve = root;

    STATE.observer = new IntersectionObserver(
    (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
        fetchAndAppend(btn.href);
        }
    },
    {
        root: null,
        rootMargin: '0px 0px',
        threshold: 0
    }
    );
    STATE.observer.observe(targetToObserve);
  };

  const watchFacetsRerender = () => {
    const target =
      document.querySelector('#ProductGridContainer') ||
      document.querySelector('.collection') ||
      getGrid(document);

    if (!target) return;

    const mo = new MutationObserver(() => {
      window.requestAnimationFrame(() => {
        if (STATE.boundRoot && !document.body.contains(STATE.boundRoot)) {
          STATE.boundRoot = null;
        }
        initLoadMore();
      });
    });

    mo.observe(target, { childList: true, subtree: true });
  };

  initLoadMore();
  watchFacetsRerender();

  window.addEventListener('popstate', () => {
    STATE.boundRoot = null;
    initLoadMore();
  });
})();